module.exports = __webpack_public_path__ + "img/2-ob3.cb98090b.png";